<template>
    <b-container  fluid v-if="userInfo && canSysAdmin(userInfo)">
        <div class="mt-3">
            <b-overlay :show="isBusy" rounded="sm" >            
                <b-card title="Card Title" no-body >
                    <b-card-header class="no-print">  
                        Dashboard
                    </b-card-header>
                    <b-card-body class="text-center p-0" >
                        <div class="row">
                            <div class="col-12">
                                <b-table-simple bordered hover small responsive>
                                    <b-thead head-variant="none">
                                        <b-tr>
                                            <b-th rowspan="2">Location</b-th>
                                            <b-th colspan="5">Today</b-th>
                                            <b-th colspan="5">7 Day Average</b-th>
                                        </b-tr>
                                        <b-tr>                                        
                                            <b-th>Orders</b-th>
                                            <b-th>Abandon</b-th>
                                            <b-th>Payment Failures</b-th>
                                            <b-th>Refunds</b-th>
                                            <b-th>Total</b-th>

                                            <b-th>Orders</b-th>
                                            <b-th>Abandon</b-th>
                                            <b-th>Payment Failures</b-th>
                                            <b-th>Refunds</b-th>
                                            <b-th>Total</b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr v-for="(item) in dataDashboardReport" :key="item.location._id">
                                            <b-td class="text-left">{{item.location.name}}</b-td>

                                            <b-td>{{item.dayLast1.ordersAverage}}</b-td>
                                            <b-td>{{item.dayLast1.abandon}}</b-td>
                                            <b-td>{{item.dayLast1.paymentFailures}}</b-td>
                                            <b-td>{{item.dayLast1.refund}}</b-td>  
                                            <b-td>{{$c2d(item.dayLast1.total) | currency}}</b-td>
                                            
                                            <b-td>{{item.dayLast7.ordersAverage}}</b-td>
                                            <b-td>{{item.dayLast7.abandon}}</b-td>
                                            <b-td>{{item.dayLast7.paymentFailures}}</b-td>
                                            <b-td>{{item.dayLast7.refund}}</b-td>  
                                            <b-td>{{$c2d(item.dayLast7.total) | currency}}</b-td>  
                                        </b-tr>     
                                    </b-tbody>
                                </b-table-simple>
                            </div>   
                        </div>         
                    </b-card-body>
                </b-card>
            </b-overlay>            
        </div>
    </b-container>
    <b-container v-else>
        You dont have access dashboard    
    </b-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name : 'List86',
    components:{  },
    props : [],
    data() { 
        return {
            isBusy:false,
            dataDashboardReport : []
        }
    },
    computed : {
        ...mapState({
            userInfo: 'userInfo',
            selectedOrganization : 'selectedOrganization' 
        }),
    },
    watch:{
         selectedOrganization: {
            deep: true,
            immediate: true,
            handler(){
                this.dashboardReport();    
            }
        }
    },
    created() { 
    },
    destroyed() { },
    methods: { 
        dashboardReport() {
            this.dataDashboardReport = []
            this.isBusy = true
            this.$store.dispatch('apiDashboardReport')
                .then(({status, res}) => {
                    this.isBusy = false
                    if(status){
                        this.dataDashboardReport = res
                    }
                }).catch(()=>{
                    this.isBusy = false
                })
        }
     },
    mounted(){
        
    }   
}
</script>
<style scoped lang="scss">

</style>